import React, { useState } from "react";
import BulkUploadDropzone from "components/Common/BulkUploadDropzone";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000,
};

const popupStyle = {
  background: "#fff",
  padding: "25px",
  width: "700px",
  borderRadius: "12px",
  textAlign: "center",
};

const titleStyle = {
  margin: "0 0 20px 0",
  fontSize: "18px",
  fontWeight: 600,
  color: "#133933",
};

const actionsStyle = {
  display: "flex",
  justifyContent: "center",
  gap: "15px",
  marginTop: "20px",
};

const cancelBtn = {
  padding: "10px 20px",
  background: "#f5f5f5",
  color: "#333",
  border: "1px solid #ccc",
  borderRadius: "15px",
  cursor: "pointer",
  fontSize: "14px",
};

const uploadBtn = {
  padding: "10px 20px",
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "15px",
  cursor: "pointer",
  fontSize: "14px",
};

const PLATFORM_TITLES = {
  Facebook: "Add Facebook Page Details",
  Instagram: "Add Instagram Account Details",
  Twitter: "Add Twitter Handle Details",
  YouTube: "Add YouTube Channel Details",
};

export default function BulkUploadModal({
  open,
  onClose,
  platform,
  onUpload,
  onError,
  title,
  accept,
  maxSize,
  sampleFileUrl,
  sampleDownloadName,
  sampleLabel,
  showGuide,
}) {
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!open) return null;

  const handleClose = () => {
    setFile(null);
    onClose();
  };

  const handleUploadClick = async () => {
    if (!file || submitting) return;
    setSubmitting(true);
    await onUpload(file);
    setSubmitting(false);
    setFile(null);
    onClose();
  };

  return (
    <div style={overlayStyle} onClick={(e) => e.target === e.currentTarget && handleClose()}>
      <div style={popupStyle}>
        <h3 style={titleStyle}>{title || PLATFORM_TITLES[platform] || "Bulk Upload"}</h3>

        <BulkUploadDropzone
          platform={platform}
          onChange={setFile}
          onError={onError}
          accept={accept}
          maxSize={maxSize}
          sampleFileUrl={sampleFileUrl}
          sampleDownloadName={sampleDownloadName}
          sampleLabel={sampleLabel}
          showGuide={showGuide}
        />

        <div style={actionsStyle}>
          <button style={cancelBtn} onClick={handleClose} type="button">
            Cancel
          </button>
          <button
            style={{ ...uploadBtn, opacity: file && !submitting ? 1 : 0.6 }}
            onClick={handleUploadClick}
            disabled={!file || submitting}
            type="button"
          >
            {submitting ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
}
